var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormSaveButton',{staticClass:"mr-4"}),_c('BackButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }